<template>
  <v-row justify="center">
    <v-row justify="center">
      <v-dialog
        v-model="this.deleteOfferAlertDisplay"
        persistent
        max-width="400"
      >
        <v-card>
          <v-card-title class="text-h5"> </v-card-title>
          <v-card-text
            >Vous êtes sur le point de supprimer une offre emploi. Voulez-vous
            poursuivre?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="deleteItemForReal" text>
              Oui, supprimer
            </v-btn>
            <v-btn
              color="red darken-1"
              text
              @click="deleteOfferAlertDisplay = false"
            >
              Non
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="deleteSnackbarFailed"
        rounded="pill"
        elevation="24"
        color="red darken-3"
      >
        <span class="text-subtitle-1">
          Une erreur s'est produite lors de la suppression de l'offre.
        </span>
        <template v-slot:action="{ attrs }">
          <v-btn
            color="black"
            text
            v-bind="attrs"
            @click="deleteSnackbarFailed = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="this.disableOfferAlert" persistent max-width="400">
        <v-card>
          <v-card-title class="text-h5"> </v-card-title>
          <v-card-text>
            En
            {{
              jobOffer.isActive
                ? "désactivant votre annonce, vous la retirez des résultats de recherche. Vous pourrez tout de même la modifier et la rediffuser à nouveau."
                : "activant vous pourrez tout de même la modifier et la désactiver à nouveau"
            }}
            <br />
            Souhaitez vous continuer?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="switchItemStateForReal" text>
              Oui, {{ jobOffer.isActive ? "désactiver" : "activer" }}
            </v-btn>
            <v-btn color="red darken-1" text @click="disableOfferAlert = false">
              Non
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialog" max-width="70%" scrollable>
      <v-card v-if="jobOffer !== null">
        <v-card-title
          class="justify-center text-h5 font-weight-light"
          style="color: #1976d2"
        >
          {{ jobOffer.job.name + " - " + jobOffer.type.name }}
        </v-card-title>
        <v-card-subtitle style="margin-top: 1em">
          <v-row>
            <v-col cols="12" md="6" class="" style="font-size: large">
              <span class="font-weight-black">
                <v-icon> mdi-home-city-outline </v-icon>
                Entreprise :
              </span>
              <router-link
                target="_blank"
                :to="`/company/page/${jobOffer.company.id}`"
                >{{ jobOffer.company.name }}</router-link
              >
            </v-col>
            <v-col cols="12" md="6" class="" style="font-size: large">
              <span class="font-weight-black">
                <v-icon> mdi-calendar-month-outline </v-icon>
                Date de publication :
              </span>
              {{ new Date(jobOffer.createdAt).toLocaleString("fr-FR") }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-domain </v-icon>
                Secteur :
              </span>
              {{ jobOffer.job.activitySector.name }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-map-marker-multiple-outline </v-icon>
                Lieu de travail :
              </span>
              {{ jobOffer.jobLocation }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-map-marker-multiple-outline </v-icon>
                Salaire (en GNF):
              </span>
              {{ jobOffer.remuneration }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-file-certificate-outline </v-icon>
                Type d'offre :
              </span>
              {{ jobOffer.type.name }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-file-certificate-outline </v-icon>
                Début d'activités :
              </span>
              {{
                jobOffer.startDate
                  ? new Date(jobOffer.startDate)
                      .toLocaleString("fr-FR")
                      .split(",")[0]
                  : "-"
              }}
            </v-col>
            <v-col
              cols="12"
              md="6"
              style="font-size: large; margin-top: -0.8em"
            >
              <span class="font-weight-black">
                <v-icon> mdi-file-certificate-outline </v-icon>
                Durée :
              </span>
              {{ jobOffer.duration !== null ? jobOffer.duration : "-" }}
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text v-html="jobOffer.description"> </v-card-text>
        <v-card-actions v-if="this.origin !== 'company'">
          <v-btn
            v-if="displaySaveButton && dialog && currentUserIsCandidate"
            rounded
            color="primary"
            dark
            @click="saveOffer"
            text
          >
            <v-icon left> mdi-content-save-settings-outline </v-icon>
            Sauvegarder cette offre
          </v-btn>
          <v-btn
            v-if="
              currentUserIsCompany &&
              jobOffer.company.id === this.currentUser.companyManager.id
            "
            rounded
            color="primary"
            dark
            text
            :to="`/company/offer/${jobOffer.id}/applications`"
          >
            <v-icon left> mdi-content-save-settings-outline </v-icon>
            Candidatures
          </v-btn>
          <v-btn
            v-if="currentUserIsCandidate || currentUserIsAnonymous"
            color="teal"
            class="ma-2 white--text"
            text
            rounded
            @click="dialog = false"
            :to="'/candidate/apply/' + this.jobOffer.id"
          >
            <v-icon left> mdi-text-box-check </v-icon>
            Postuler
          </v-btn>
          <v-btn
            v-if="
              currentUserIsCompany &&
              jobOffer.isActive &&
              jobOffer.company.id === this.currentUser.companyManager.id
            "
            color="success"
            text
            class="ma-2 white--text"
            rounded
            @click="switchItemState"
          >
            <v-icon left> mdi-text-box-check </v-icon>
            Désactiver
          </v-btn>
          <v-btn
            v-if="currentUserIsCompany && !jobOffer.isActive"
            color="success"
            text
            class="ma-2 white--text"
            rounded
            @click="switchItemState"
          >
            <v-icon left> mdi-check-underline-circle-outline </v-icon>
            Activer
          </v-btn>
          <v-btn
            v-if="
              currentUserIsCompany &&
              jobOffer.company.id === this.currentUser.companyManager.id
            "
            color="teal"
            class="ma-2 white--text"
            text
            rounded
            @click="dialog = false"
            :to="'/company/edit/offer/' + this.jobOffer.id"
          >
            <v-icon left> mdi-application-edit-outline </v-icon>
            Editer
          </v-btn>
          <v-btn
            v-if="
              currentUserIsCompany &&
              jobOffer.company.id === this.currentUser.companyManager.id
            "
            color="error"
            class="ma-2 white--text"
            text
            rounded
            @click="deleteItem"
          >
            <v-icon left> mdi-text-box-check </v-icon>
            Supprimer
          </v-btn>

          <v-btn
            rounded
            color="blue-grey"
            class="ma-2 white--text"
            text
            @click="hideModal"
          >
            <v-icon left> mdi-close-box-multiple </v-icon>

            Fermer
          </v-btn>
          <v-snackbar
            v-model="snackbarSaveOfferSuccess"
            elevation="24"
            color="green darken-3"
          >
            <span class="text-subtitle-1">
              L'offre a bien été enregistrée. Vous pourrez là retrouver plus
              tard dans le menu « Mes recherches »
            </span>
            <template v-slot:action="{ attrs }">
              <v-btn
                color="black"
                text
                v-bind="attrs"
                @click="snackbarSaveOfferSuccess = false"
              >
                Fermer
              </v-btn>
            </template>
          </v-snackbar>
          <v-snackbar
            v-model="snackbarSaveOfferFailed"
            rounded="pill"
            elevation="24"
            color="red darken-3"
          >
            <span class="text-subtitle-1">
              Cette offre a déjà été enregistrée.
            </span>
            <template v-slot:action="{ attrs }">
              <v-btn
                color="black"
                text
                v-bind="attrs"
                @click="snackbarSaveOfferFailed = false"
              >
                Fermer
              </v-btn>
            </template>
          </v-snackbar>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";

export default {
  name: "ViewJobOffer",
  props: {
    jobOffer: Object,
    displayDialog: Boolean,
    hideModalComponentCallback: Function,
    displaySaveButtonProps: Boolean,
    origin: String,
  },
  data() {
    return {
      dialog: false,
      snackbarSaveOfferSuccess: false,
      snackbarSaveOfferFailed: false,
      displaySaveButton: true,
      currentUser: null,
      currentUserIsAnonymous: false,
      currentUserIsCandidate: false,
      currentUserIsCompany: false,
      deleteOfferAlertDisplay: false,
      disableOfferAlert: false,
      deleteSnackbarFailed: false,
    };
  },
  mounted() {
    this.dialog = this.displayDialog;
    this.displaySaveButton = this.displaySaveButtonProps;

    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser === null || currentUser === undefined) {
      this.currentUserIsAnonymous = true;
    } else {
      if (currentUser.roles.includes("ROLE_COMPANY")) {
        this.currentUserIsCandidate = false;
        this.currentUserIsCompany = true;
      } else {
        this.currentUserIsCandidate = true;
        this.currentUserIsCompany = false;
      }
    }

    this.currentUser = currentUser;
  },
  methods: {
    hideModal() {
      this.dialog = false;
    },
    saveOffer() {
      const httpClient = new HttpClient();
      const user = JSON.parse(localStorage.getItem("currentUser"));
      httpClient
        .saveJobOffer(
          {
            jobOffer: this.jobOffer.id,
            seeker: user.seeker.id,
          },
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          this.snackbarSaveOfferSuccess = true;
          setTimeout(() => {
            this.snackbarSaveOfferSuccess = false;
          }, 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else if (err.response.status === 503) {
            this.snackbarSaveOfferFailed = true;
            setTimeout(() => {
              this.snackbarSaveOfferFailed = false;
            }, 3000);
          } else {
            alert("Une erreur s'est produite");
            console.log(err);
          }
        });
    },
    deleteItem() {
      this.deleteOfferAlertDisplay = true;
    },
    deleteItemForReal() {
      this.deleteOfferAlertDisplay = false;
      const item = this.jobOffer;
      const httpClient = new HttpClient();
      httpClient
        .putFromApiPlatformUri(
          "/api/job_offers/" + item.id,
          {
            isDeleted: true,
            deletedAt: new Date(),
          },
          localStorage.getItem("jwt-token")
        )
        .then(() => {
          this.dialog = false;
          window.location = "/company/offers?deleted";
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            this.deleteSnackbarFailed = true;
            setTimeout(() => {
              this.deleteSnackbarFailed = false;
            }, 3000);
          }
        });
    },
    switchItemState() {
      this.disableOfferAlert = true;
    },
    switchItemStateForReal() {
      this.disableOfferAlert = false;
      const item = this.jobOffer;
      const httpClient = new HttpClient();
      let snackBarParameter = item.isActive ? "disabled" : "enabled";
      console.log(snackBarParameter);
      httpClient
        .putFromApiPlatformUri(
          "/api/job_offers/" + item.id,
          {
            isActive: !item.isActive,
          },
          localStorage.getItem("jwt-token")
        )
        .then(() => {
          this.dialog = false;
          window.location = "/company/offers?" + snackBarParameter;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.hideModalComponentCallback();
      }
    },
  },
};
</script>

<style scoped></style>
